import clsx from 'clsx';
import logo from '../../assets/images/logo.svg';
import illustration from '../../assets/images/screen-too-small.svg';
import styles from './ScreenTooSmall.module.css';

export function ScreenTooSmall() {
  return (
    <div className={clsx(styles.page)}>
      <header className={clsx(styles.header)}>
        <img className={clsx(styles.logo)} src={logo} alt="Waythru" />
      </header>
      <div className={clsx(styles.content)}>
        <img src={illustration} alt="" aria-hidden="true" />
        <div className={clsx(styles.textBlock)}>
          <h1 className={clsx(styles.title)}>Unsupported device</h1>
          <p className={clsx(styles.body)}>
            This application is not available on mobile or tablet devices.
            <br />
            Please access it from a desktop browser.
          </p>
        </div>
      </div>
    </div>
  );
}
